const imageVersionEnum = Object.freeze({
  IMAGE_INFO_VERSION: 'image_info_version',
  PREVIEW_VERSION: 'preview_version',
});

export default imageVersionEnum;
